import React, { useState } from 'react';
import PropTypes from 'prop-types';
import searchIcon from 'assets/images/icons/search.svg';
import TextField from 'components/form-components/TextField';

const UsersListHeader = ({ filteringData, setFilteringData }) => {
  const [searchText, setSearchText] = useState('');

  const handleChange = (name, value) => {
    setFilteringData({ ...filteringData, [name]: value });
  };

  return (
    <div className='section-header d-flex align-items-center px-2'>
      <TextField
        value={searchText}
        name='searchText'
        handleChange={(_, value) => setSearchText(value)}
        placeholder='field_search_mobile_number'
        icon={searchIcon}
        shrink
        debounceFunc={handleChange}
      />
    </div>
  );
};

UsersListHeader.propTypes = {
  filteringData: PropTypes.object,
  setFilteringData: PropTypes.func,
};

export default UsersListHeader;
